import { Button } from 'components/ui/button';
import URL from 'utils/url';
import { oneAppUrl } from 'utils/urlGenerator';
import { ENV } from 'utils/config';
import { AssistanceFooter } from 'components/stores/AssistanceFooter';

const EmptyStoresList = () => {
  return (
    <div className="mt-7 w-1/2 flex flex-col items-start justify-between pt-12 pb-6 rounded-3xl bg-white mx-6 xl:w-full xl:items-center xl:m-0 xl:rounded-none xl:pt-6">
      <div className="px-11">
        <h1 className="text-2xl font-semibold leading-8 text-gray-blue-90 mb-2">
          Welcome to your TreezPay portal!
        </h1>
        <p className="text-base font-normal leading-6 text-gray-blue-70 pb-3 mb-3">
          Manage all payment options in one place, simplifying reconciliation
          and obtaining customer transaction data to gain valuable insights.
        </p>
        <div className="text-sm font-normal leading-5 text-gray-blue-70 mb-5">
          <span>
            First step is to fill out the{' '}
            <span className="font-semibold text-gray-blue-90">
              TreezPay One Application
            </span>{' '}
            to get approved for all TreezPay options simultaneously.
          </span>
        </div>
        <div className="flex flex-col">
          <Button
            onClick={() => URL.openInNewTab(oneAppUrl(ENV))}
            role="link"
            type="button"
            className="bg-treez-green hover:opacity-90 text-dark-green-text px-6 py-2 rounded font-medium text-base"
          >
            Start Application
          </Button>
          <span className="text-sm font-normal leading-5 text-gray-blue-70 mr-1">
            Already started your application?
          </span>
          <span className="text-sm font-normal leading-5 text-gray-blue-70">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={oneAppUrl(ENV)}
              className="text-dark-green-link underline hover:no-underline"
            >
              Click here
            </a>{' '}
            to resume.
          </span>
        </div>
        <div className="text-base font-semibold leading-6 text-gray-blue-90 mt-7 pt-1">
          <span>Curious to see it in action?</span>
        </div>
        <div className="text-sm font-normal leading-5 text-gray-blue-60">
          <span>
            Check out a{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/watch?v=59fSttMQ10E"
              className="text-dark-green-link underline hover:no-underline"
            >
              quick video
            </a>{' '}
            previewing{' '}
            <span className="font-semibold text-gray-blue-90">
              'TreezPay 2.0'{' '}
            </span>
            to see the future of TreezPay cashless payments.
          </span>
        </div>
      </div>
      <AssistanceFooter />
    </div>
  );
};

export default EmptyStoresList;
